<div class="action">
  <app-popup-top-line></app-popup-top-line>
  <div class="title-row">
    <div class="title">{{ 'playbooks.actions' | labelsProvider }}</div>
    <img src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>
  <div class="content">
    <div class="left">
      <div class="title">
        {{ 'playbooks.action' | labelsProvider }}
        {{ 'common.list' | labelsProvider }}
      </div>
      @for (option of actionOptions(); track option.type) {
        <div
          class="action-option"
          [ngClass]="{
            selected: option.type === selectedAction,
            disabled: option.disabled,
          }"
          (click)="onActionSelected(option)"
          [matTooltip]="option.tooltip ? option.tooltip : isTruncated(option.type) ? option.name : ''"
          matTooltipPosition="above"
          matTooltipClass="tooltip-container"
          [matTooltipDisabled]="!option.tooltip && !isTruncated(option.type)"
        >
          <div #actionTitleRef class="action-option-title">{{ option.name }}</div>
          @if (option.type === selectedAction) {
            <img class="action-option-selected" src="assets/images/common/selected.svg" />
          }
        </div>
      }
    </div>
    <div class="right">
      <div class="title">
        {{ 'playbooks.action' | labelsProvider }}
        {{ 'common.properties' | labelsProvider }}
        {{ 'common.settings' | labelsProvider }}
      </div>
      <div>
        @if (selectedAction === actionTypes.sendEmail) {
          <app-send-email-action [fg]="fg" [playbooksActionInput]="actionFormInput" [trigger]="actionInput.trigger">
          </app-send-email-action>
        }

        @if (selectedAction === actionTypes.sendWebhook) {
          <app-send-webhook-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-send-webhook-action>
        }

        @if (selectedAction === actionTypes.sendToSoc) {
          <app-send-to-soc-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-send-to-soc-action>
        }

        @if (!!(showAddOwnerAction$ | async)) {
          <app-add-owner-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-add-owner-action>
        }

        @if (!!(showRemovePermissionsAction$ | async)) {
          <app-remove-permissions-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-remove-permissions-action>
        }

        @if (!!(showIsolateResourceAction$ | async)) {
          <app-isolate-resource-action> </app-isolate-resource-action>
        }

        @if (showRemoveAccessAction$ | async) {
          <app-remove-access-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-remove-access-action>
        }

        @if (showDeleteAgentAction$ | async) {
          <!-- No additional inputs required for delete agent action -->
        }

        @if (showDeletePowerBIResourceAction$ | async) {
          <!-- No additional inputs required for delete Power BI resource actions -->
        }

        @if (showSetAllUsersAccessWorkspaceAction$ | async) {
          <app-set-all-users-access-power-bi-workspace-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-set-all-users-access-power-bi-workspace-action>
        }

        @if (selectedAction === actionTypes.wait) {
          <app-wait-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-wait-action>
        }

        @if (selectedAction === actionTypes.secureFlowSteps) {
          <app-secure-flow-steps-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-secure-flow-steps-action>
        }

        @if (selectedAction === actionTypes.setCopilotAuthentication) {
          <app-set-copilot-authentication-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-set-copilot-authentication-action>
        }

        @if (selectedAction === actionTypes.addLabel) {
          <app-add-label-action
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-add-label-action>
        }

        @if (selectedAction === actionTypes.setActionStatus) {
          <app-set-action-status-action
            [(actionStatus)]="actionStatus"
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-set-action-status-action>
        }

        @if (selectedAction === actionTypes.setAgentActionAuthenticationMode) {
          <app-set-authentication-mode
            [(selectedAuthenticationMode)]="authenticationMode"
            [(ignoreIfAutonomousWithTriggers)]="ignoreIfAutonomousWithTriggersAuth"
            [fg]="fg"
            [labelKey]="'commonActions.authenticationMode'"
          >
          </app-set-authentication-mode>
        }

        @if (selectedAction === actionTypes.setAgentActionConfirmationMode) {
          <app-set-confirmation-mode
            [(selectedConfirmationMode)]="confirmationMode"
            [(ignoreIfAutonomousWithTriggers)]="ignoreIfAutonomousWithTriggersConf"
            [fg]="fg"
            [labelKey]="'commonActions.confirmationMode'"
          >
          </app-set-confirmation-mode>
        }

        @if (selectedAction === actionTypes.setAgentWebBrowsing) {
          <app-set-web-browsing-action
            [(webBrowsingMode)]="webBrowsingMode"
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-set-web-browsing-action>
        }

        @if (selectedAction === actionTypes.setEnvironmentAudit) {
          <app-set-environment-audit-action
            [(auditMode)]="auditMode"
            [fg]="fg"
            [playbooksActionInput]="actionFormInput"
            [triggerType]="actionInput.trigger.triggerType"
          >
          </app-set-environment-audit-action>
        }
      </div>
    </div>
  </div>

  @if (selectedAction) {
    <div class="buttons-container">
      <div class="cancel" (click)="closeWindow()">
        {{ 'common.cancel' | labelsProvider }}
      </div>
      <div class="confirm" [ngClass]="{ 'confirm-disabled': fg.invalid }" (click)="createOrUpdate()" cdkFocusInitial>
        <span>{{ playbookAction ? ('common.save' | labelsProvider) : ('common.create' | labelsProvider) }}</span>
      </div>
    </div>
  }
</div>
